module.exports = __webpack_public_path__ + "media/images/icons/filled/stop-9256747dcea9d68e184fcff366b39186.svg";